export var FETCH_CARDS = 'FETCH_CARDS';
export var SUCCESS_FETCH_CARDS = 'SUCCESS_FETCH_CARDS';
export var FAILURE_FETCH_CARDS = 'FAILURE_FETCH_CARDS';



// WEBPACK FOOTER //
// ./src/actions/plastic/index.js